import schoolTheme from "./schoolFuturisticTheme.json";

export const systemThemes = [
  {
    id: schoolTheme.themeId,
    name: schoolTheme.themeName,
    previewThumbnail: schoolTheme.themeVars.backgroundGradient,
    theme: schoolTheme, // ✅ MUST be "theme", not "structure"
  }
];
